// import { IAdminData } from "./../../interfaces/admin.interface";
// import { IHttp, IHttpResponse } from "./../../interfaces/http.interface";
import axiosInstance from "../../axios/axios";
import { requestHeader } from "./sharedUtils";
import { ListOrdersPayloadDto } from "./dtos/ListOrdersPayloadDto";

export const getAllOrder = async (
  data: ListOrdersPayloadDto
): Promise<[any, any]> => {
  try {
    const response = await axiosInstance.get(`/Orders/List`, {
      headers: requestHeader.headers,
      params: { ...data },
    });
    return [response.data.data, null];
  } catch (err) {
    return [null, err];
  }
};

export const getAllAdminOrder = async (
  data: ListOrdersPayloadDto
): Promise<[any, any]> => {
  try {
    const response = await axiosInstance.get(`/Orders/List-for-admin`, {
      headers: requestHeader.headers,
      params: { ...data },
    });
    return [response.data.data, null];
  } catch (err) {
    return [null, err];
  }
};

export const getFileList = async (sono: any) => {
  try {
    const response = await axiosInstance.get(
      `/Orders/order-description/${sono}`,
      requestHeader
    );
    return [response.data.data, null];
  } catch (err) {
    return [null, err];
  }
};

export const getPaymentToken = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      `/payment/token`,
      data,
      requestHeader
    );
    return [response.data.data, null];
  } catch (err) {
    return [null, err];
  }
};

export const cardPayment = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      `/payment/creditcard`,
      data,
      requestHeader
    );
    return [response.data.data, null];
  } catch (err) {
    return [null, err];
  }
};

export const getPaymentAmount = async (data: any) => {
  try {
    const response = await axiosInstance.get(
      `/payment/pay-amount?sono=${data}`,
      requestHeader
    );
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const completedLocalTransaction = async (sono: string) => {
  try {
    const response = await axiosInstance.post(
      `/payment/completedLocalTransaction?sono=${sono}`,
      {},
      requestHeader
    );
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const materialSubmit = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      `/materials/orderMaterials`,
      data,
      requestHeader
    );
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};
